// @flow
import React, { Component, ComponentType } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import dateFormat from "dateformat";

import SpinnerIcon from "@atlaskit/spinner";

import { decode } from "../utils/string";
import { event } from "../utils/events";

import { Title, Text, Form, Buttons, SpinnerWrapper } from "./styled";

type Props = {|
    open: boolean,
    onHide: Function,
    Dialog: ComponentType<any>,
    onFetchBlogs: Function,
    submitState: Object,
    diary: Object
|};

class WriteJournal extends Component<Props> {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    componentDidMount() {
        console.log("Should load rich text editor?");
    }

    onClose = () => {
        this.props.onHide();
    };

    initialState = () => {
        const { submitState } = this.props;
        let { diary } = this.props;
        if (diary === undefined) {
            const today = dateFormat(new Date(), "yyyy-mm-dd");

            diary = {
                startDate: today,
                endDate: today,
                title: "",
                text: ""
            };
        }

        const state = {
            submitState,
            diary
        };

        return state;
    };

    handleChange = name => e => {
        const { diary } = this.state;
        diary[name] = e.target.value;
        this.setState({ diary });
    };

    saveJournal = async () => {
        const { title, text, startDate, endDate } = this.state.diary;
        this.setState({ submitState: "submitting" });
        event({
            category: `Submitting data`,
            action: "Journal"
        });

        const data = new URLSearchParams();
        data.append("action", "editdiary");
        data.append("submitting", "1");
        data.append("start_date", startDate);
        data.append("end_date", endDate);
        data.append("title", title);
        data.append("text", text);

        console.log("Saving Journal");

        await fetch("https://www.getjealous.com/admin.php", {
            method: "POST", // *GET, POST, PUT, DELETE, etc.
            credentials: "include", // include, same-origin, *omit
            body: data // body data type must match "Content-Type" header
        });

        this.props.onFetchBlogs();

        this.setState(this.initialState());
        this.onClose();
    };

    render() {
        const { Dialog, open } = this.props;
        const { submitState, diary } = this.state;
        const { title, text, startDate, endDate, id } = diary;

        return (
            <div>
                <Dialog open={open} showCloseButton={false} onHide={this.onClose}>
                    <Form>
                        <Title>{id ? "Edit Journal" : "Write Journal"}</Title>
                        <Text>Tell everyone where you have been and what you have been up to.</Text>
                        <TextField
                            label="Start Date"
                            onChange={this.handleChange("startDate")}
                            defaultValue={startDate}
                            type="date"
                        />
                        <TextField
                            label="End Date"
                            onChange={this.handleChange("endDate")}
                            defaultValue={endDate}
                            type="date"
                        />
                        <TextField
                            style={{ width: "75%" }}
                            required
                            label="Title"
                            onChange={this.handleChange("title")}
                            defaultValue={decode(title)}
                        />
                        <TextField
                            style={{ width: "90%" }}
                            fullWidth
                            multiline
                            required
                            label="Journal"
                            onChange={this.handleChange("text")}
                            defaultValue={decode(text)}
                        />
                        <Buttons>
                            <Button onClick={this.onClose} variant="contained" color="secondary">
                                Close
                            </Button>
                            <Button
                                disabled={
                                    submitState === "submitting" || text === "" || title === ""
                                }
                                onClick={this.saveJournal}
                                variant="contained"
                                color="primary"
                            >
                                Publish Journal
                            </Button>
                            {(submitState === "submitting" || submitState === "submitted") && (
                                <SpinnerWrapper>
                                    <SpinnerIcon
                                        size="medium"
                                        isCompleting={submitState === "submitted"}
                                        onComplete={this.onClose}
                                        style={{ backgroundColor: "#000" }}
                                    />
                                </SpinnerWrapper>
                            )}
                        </Buttons>
                    </Form>
                </Dialog>
            </div>
        );
    }
}

export default WriteJournal;



// WEBPACK FOOTER //
// ./src/write-journal-dialog/view.js